// extracted by mini-css-extract-plugin
module.exports = {"addButton":"AddButton_addButton__1hF_Q","text":"AddButton_text__naE-k"};